<div class="container-fluid">
  <div class="row">
    <div class="col-xl-12">
      <h1 class="page-hd">Dispute List</h1>
      <div class="content-wrap">
        <div class="table-responsive">
          <table class="ui celled table hover" datatable [dtTrigger]="dtTrigger" [dtOptions]="dtOptions">
            <thead>
              <tr>
                <th>Name</th>
                <th>Application Id</th>
                <th>Email</th>
                <th>Phone Number</th>
                <th>Preview Document</th>
                <th>Dispute Details</th>
                <th>Application Details</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of request">

                <td>{{data.first_name}} {{data.last_name}}</td>
                <td>{{data.application_id}}</td>
                <td>{{data.emailid}}</td>
                <td>{{data.phone_no}}</td>
                <td>
                  <!-- <button class='action-btn bg-theme' data-toggle="modal" data-target="#viewModal"
                    (click)="openModal(data.verification_id)">Preview</button> -->
                    <button class="approve-modal-btn bg-theme mr-auto" data-dismiss="modal"
                    (click)="openModal(data.verification_id)">Preview</button>
                  
                  </td>
                <td><button class='action-btn bg-theme' data-toggle="modal" data-target="#disputeDetails"
                    (click)="showReason(data.reason)">View</button></td>
                <td>
                  <button class='action-btn bg-theme' data-toggle="modal" data-target="#applicationDetails"
                    (click)="getAppData(data.verification_id)">View</button>
                  </td>
                <td>
                  <button class='action-btn2 mr-3' data-toggle="modal" name="NCL" data-target="#viewNCLConfirm"
                    (click)="getDataForStatusChange(data.id, 'NCL',data)">No change & close</button>
                  <!-- (click)="updateDisputeStatus(data.id,'NCL')" -->
                  <button class='action-btn2' data-toggle="modal" name="CL" data-target="#viewCLConfirm"
                    (click)="getDataForStatusChange(data.id, 'CL',data)">Change & close</button>
                  <!-- (click)="updateDisputeStatus(data.id,'CL')" -->
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #showModalBoxImage let-modal>
  <div class="modal-content">
    <div class="modal-header bg-theme">
      <h5 class="modal-title" id="viewModalLabel">Preview Document</h5>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-6">
          <div *ngIf="!isVrPdf && !noImage1">
            <app-magnify  [imageId]="imgname" [ImageURL]="upload_doc_path"> </app-magnify>
          </div>
          <p class="doc-txt">Appicant's document</p>
          <!-- <img src={{upload_doc_path}} class="doc-img" (click)="showLightbox(0)"> -->
          <div *ngIf="isVrPdf">
            <div class="ng-star-inserted22">
              <pdf-viewer [src]="src" [zoom]="1"></pdf-viewer>
            </div>
            <button class="new-tab-btn" (click)="openPdf()">Open Doc in Browser</button>
          </div>
          <div *ngIf="isVrImage">
            <!-- <img src={{upload_doc_path}} class="doc-img" (click)="showLightbox(0)"> -->
            <div class="img-magnifier-container">
              <img src={{upload_doc_path}}  class="doc-img" id="uploadImg1"  (click)="showLightbox(0)" loading="lazy">
            </div>
        
          </div>

        </div>
        <div class="col-md-6">
          <div *ngIf="!isUPdf && !noImage2">
            <app-magnify  [imageId]="imgname2" [ImageURL]="originalDocUploadFilePath"> </app-magnify>
          </div>
          <p class="doc-txt">System document</p>
          <!-- <img src={{originalDocUploadFilePath}} class="doc-img" (click)="showLightbox(1)"> -->
          <div *ngIf="isUPdf">
            <div class="ng-star-inserted22">
              <pdf-viewer [src]="src1" [zoom]="1"></pdf-viewer>
            </div>
            <button class="new-tab-btn" (click)="openPdf1()">Open Doc in Browser</button>
          </div>
          <div *ngIf="isUImage">
            <!-- <img src={{originalDocUploadFilePath}} class="doc-img" (click)="showLightbox(1)" loading="lazy"> -->
            <div class="img-magnifier-container">
              <img src={{originalDocUploadFilePath}}  class="doc-img"  id="uploadImg2" (click)="showLightbox(1)" loading="lazy">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</ng-template>
<div class="modal fade" id="viewModal" tabindex="-1" role="dialog" aria-labelledby="viewModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header bg-theme">
        <h5 class="modal-title" id="viewModalLabel">Preview Document</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-6">
            <p class="doc-txt">Appicant's document</p>
            <!-- <img src={{upload_doc_path}} class="doc-img" (click)="showLightbox(0)"> -->
            <div *ngIf="isVrPdf">
              <div class="ng-star-inserted22">
                <pdf-viewer [src]="src" [zoom]="1"></pdf-viewer>
              </div>
              <button class="new-tab-btn" (click)="openPdf()">Open Doc in Browser</button>
            </div>
            <div *ngIf="isVrImage">
              <img src={{upload_doc_path}} class="doc-img" (click)="showLightbox(0)">
            </div>

          </div>
          <div class="col-md-6">
            <p class="doc-txt">System document</p>
            <img src={{originalDocUploadFilePath}} class="doc-img" (click)="showLightbox(1)">

          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="viewCLConfirm" tabindex="-1" role="dialog" aria-labelledby="viewCLConfirmLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header bg-theme">
        <h5 class="modal-title" id="viewModalLabel">Status</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p>The status of the record will be reversed and the user will be notified via mail.</p>

        <p>
          Select Status:        
        </p>
        <label class="form-check-label" *ngIf="documentStatus=='UN_Approved_Fail' || documentStatus=='UN_Rejected'">
          <input  #radioInput [(ngModel)]="disputeNewStatus" (click)="changeStatus($event)" value="SVD_Approved_Pass" type="radio">
          Match And Pass &nbsp;&nbsp;&nbsp;
        </label>
        <label class="form-check-label" *ngIf="documentStatus=='UN_Approved_Pass' || documentStatus=='UN_Rejected'">
          <input #radioInput1 [(ngModel)]="disputeNewStatus" (click)="changeStatus($event)" value="SVD_Approved_Fail" type="radio">
            Match And Fail &nbsp;&nbsp;&nbsp;
        </label>
        <label class="form-check-label" *ngIf="documentStatus=='UN_Approved_Pass' || documentStatus=='UN_Approved_Fail'">
          <input #radioInput2 [(ngModel)]="disputeNewStatus" (click)="changeStatus($event)" value="SVD_Rejected" type="radio">   Negative

        </label>
        <!-- <div class="form-check-inline">
          <label class="form-check-label">
            <input type="radio" class="form-check-input"   (click)="changeStatus($event)" checked="checked" name="radio" [(ngModel)]="radio"
              [value]="true">Match And Pass
          </label>

          <label class="form-check-label">
            <input type="radio" class="form-check-input" name="radio" [(ngModel)]="radio" [value]="false">Match And Fail
          </label>

          <label class="form-check-label">
            <input type="radio" class="form-check-input" name="radio" [(ngModel)]="radio" [value]="false">Negative
          </label>
        </div> -->
        <br>
        <br>
        <p>Are you sure you want to change and close?</p>
        <br>
        <button [disabled]="!IsStatusSelected" class='action-btn2 bg-theme mr-3' data-dismiss="modal"
          (click)="updateDisputeStatus()">Yes</button>
        <button class='action-btn2 mr-3' data-dismiss="modal">No</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="viewNCLConfirm" tabindex="-1" role="dialog" aria-labelledby="viewNCLConfirmLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header bg-theme">
        <h5 class="modal-title" id="viewModalLabel">Status</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p>The status of the record will remain the same and the user will be notified via mail.</p>
        <p>Are you sure you want to close without change?</p>
        <button class='action-btn2 bg-theme mr-3' data-dismiss="modal" (click)="updateDisputeStatus()">Yes</button>
        <button class='action-btn2 mr-3' data-dismiss="modal">No</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="disputeDetails" tabindex="-1" role="dialog" aria-labelledby="disputeModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header bg-theme">
        <h5 class="modal-title" id="disputeModalLabel">Dispute Details</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <!-- <div class="row">
              <div class="col-md-12">
                <div class="form-group input-group-lg">
                    <label for="phoneNumber" class="form-label mb-0">Application Id</label>
                    <span class="appId">AP234</span>
                </div>
              </div>
          </div>
        <div class="row">
            <div class="col-md-12">
              <div class="form-group input-group-lg">
                  <label for="phoneNumber" class="form-label mb-0">Contact Person Name</label>
                  <span class="appId">Ramesh Singh</span>
              </div>
            </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group input-group-lg">
              <label for="phoneNumber" class="form-label mb-0">Contact Person Number</label>
              <span class="appId">+91 9877677557</span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group input-group-lg">
              <label for="phoneNumber" class="form-label mb-0">Contact Person Email</label>
              <span class="appId">ramesh@gmail.com</span>
            </div>
          </div>
      </div> -->
        <div class="row">
          <div class="col-md-12">
            <div class="form-group input-group-lg">
              <!-- <label for="phoneNumber" class="form-label mb-0">Dispute Reason</label> -->
              <!-- <span class="appId">The reason for this dispute is lorum ipsum 
                  kolo donar. The reason for this dispute is 
                  lorum ipsum kolo donar. The reason for this 
                  dispute is lorum ipsum kolo donar. </span> -->
              <span class="appId">{{reason}} </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="applicationDetails" tabindex="-1" role="dialog" aria-labelledby="appModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header bg-theme">
        <h5 class="modal-title" id="disputeModalLabel">Application Details</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-4">
            <div class="form-group input-group-lg">
              <label for="phoneNumber" class="form-label mb-0">Application Date</label>
              <span class="appId">{{ApplicationDate}}</span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group input-group-lg">
              <label for="phoneNumber" class="form-label mb-0">Verifier Name</label>
              <span class="appId">{{VerifierName}}</span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group input-group-lg">
              <label for="phoneNumber" class="form-label mb-0">Status</label>
              <span class="appId">{{StatusOpen}}</span>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <div class="form-group input-group-lg">
              <label for="phoneNumber" class="form-label mb-0">First Name</label>
              <span class="appId">{{first_name}}</span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group input-group-lg">
              <label for="phoneNumber" class="form-label mb-0">Last Name</label>
              <span class="appId">{{last_name}}</span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group input-group-lg">
              <label for="phoneNumber" class="form-label mb-0">Year of passing</label>
              <span class="appId">{{monthOfPassing}}/{{year}}</span>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <div class="form-group input-group-lg">
              <label for="phoneNumber" class="form-label mb-0">College Name</label>
              <span class="appId">{{college_name}}</span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group input-group-lg">
              <label for="phoneNumber" class="form-label mb-0">Stream Name</label>
              <span class="appId">{{stream_name}}</span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group input-group-lg">
              <label for="phoneNumber" class="form-label mb-0">Branch Name</label>
              <span class="appId">{{branch_nm}}</span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group input-group-lg">
              <label for="phoneNumber" class="form-label mb-0">Semester</label>
              <span class="appId">{{semester}}</span>
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-group input-group-lg">
              <label for="phoneNumber" class="form-label mb-0">Document name</label>
              <span class="appId">{{doc_name}}</span>
            </div>
          </div>

        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group input-group-lg">
              <label for="phoneNumber" class="form-label mb-0">Remark</label>
              <span class="appId">{{Remark}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #showModalBox class="modal fade " id="successModal" tabindex="-1" role="dialog" let-c="close"
  let-d="dismiss" aria-labelledby="resetPasswordModalLabel" aria-hidden="false">

  <div class="modal-content">
    <div class="modal-header success-modal-header">
      <h5 class="modal-title icon-title" id="resetPasswordModalLabel">
        <span class="icon-wrap bg-theme"><img src="assets/images/thumb-up.png" class="fa-icon-modal" alt="img"></span>

      </h5>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12">
          <h3 class="success-text">Success</h3>
          <p class="reset-hd2">Status has been updated.</p>
        </div>
      </div>
      <button class="approve-modal-btn2 bg-theme mr-auto" data-dismiss="modal" (click)="refresh()">Done</button>
    </div>
  </div>

</ng-template>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="timer" [fullScreen]="true">
  <p style="color: white"> Loading... </p>
</ngx-spinner>

<ng-image-fullscreen-view [images]="imageObject" [imageIndex]="selectedImageIndex" [show]="showFlag"
  (close)="closeEventHandler()"></ng-image-fullscreen-view>